import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type OrderTemplateFormSchema, orderTemplateFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { OrderTemplateForm } from "@/forms/order-template-form";
import { client } from "@/hono";

/** Props Interface */
interface AddOrderTemplateModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
	initialSelection?: string[];
}

export function AddOrderTemplateModal({
	onClose,
	isOpen,
	onComplete,
	initialSelection,
}: AddOrderTemplateModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(orderTemplateFormSchema),
		defaultValues: {
			name: "",
			scope: "global",
			articleIds: initialSelection || [],
		},
	});

	/** Functions */
	async function handleOnSubmit(json: OrderTemplateFormSchema) {
		const response = await client.stock["order-templates"].$post({ json });
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.create_order_template")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
				width="95vw"
			>
				<Modal.Body>
					<OrderTemplateForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
